import { Model, User } from "@/models";

export default class ContractUser extends Model {
  static type = "contractUsers";

  contractId!: string;
  userId!: string;
}
